
import { defineComponent } from "vue";
import { Qalendar } from "qalendar";
import { clientServices } from "./clientServices.service";
import dayjs from "dayjs";
import { getRoles } from "@/services/config";
import { ToastFactory } from "@/utils/ToastFactory";
import {
  ScheduleGetUser,
  ScheduleEventList,
} from "@/interfaces/Schedule.interface";
const clientService = new clientServices();

export default defineComponent({
  name: "DashboardClient",
  components: { Qalendar },
  data() {
    return {
      userRoles: getRoles(),
      schedules: [] as ScheduleEventList[],
      currentBalance: 0,
      name: JSON.parse(localStorage.getItem("userInfo") || "{}").name,
      nextDate: {
        startDate: "",
        endDate: "",
        startHour: "",
        endHour: "",
        id: "",
      },
      config: {
        locale: navigator.language,
        defaultMode: "week",
        isSilent: true,
        showCurrentTime: true,
        week: {
          startsOn: "sunday",
        },
        dayBoundaries: {
          start: 7,
          end: 22,
        },
        style: {
          FontFamily: "Inter",
          colorSchemes: {
            group: {
              color: "#153c59",
              backgroundColor: "#DFEDFC",
              borderLeft: "4px solid #153c59",
            },
          },
        },
      },
    };
  },

  methods: {
    openEvent(event: any) {
      this.$router.push({ name: "EditScheduleClient", params: { id: event } });
    },
    goToMac(id: string) {
      this.$router.push({ name: "TutorialRustDesk", params: { id } });
    },

    confirmDelete(id: any) {
      this.$confirm.require({
        header: "Excluir Agendamento",
        message: "Deseja realmente excluir este agendamento?",
        accept: () => {
          this.deleteSchedule(id);
        },
        reject: () => {},
      });
    },

    deleteSchedule(id: any) {
      clientService
        .deleteSchedule(id)
        .then(() => {
          this.nextDate = {
            startDate: "",
            endDate: "",
            startHour: "",
            endHour: "",
            id: "",
          };
          this.getScheduleUser();
        })
        .catch((e) => {
          this.$toast.add(
            ToastFactory.error(this.codeError(e.response.data.code))
          );
        });
    },

    codeError(error: any): string {
      switch (error) {
        case "SCHEDULE_STARTED":
          return this.$t("errors.scheduleStarted");
        default:
          return this.$t("toast.errorScheduleDelete");
      }
    },

    async getCurrentBalance() {
      await clientService.getBalanceUser().then((response: any) => {
        this.currentBalance = response.currentCredit;
      });
    },

    getScheduleUser(): any {
      clientService.getScheduleUser().then((response) => {
        let schedules = response;
        let events: any[] = [];

        schedules.forEach((schedule: ScheduleGetUser) => {
          const start = dayjs(schedule.initDate);
          const end = dayjs(schedule.finishDate);
          const duration = end.diff(start, "days");

          for (let i = 0; i <= duration; i++) {
            const date = dayjs(start).add(i, "day");
            const dayOfWeek = date.day();
            const mapDays = schedule.calendarList[0].daysWeek.map(
              (day: any) => day.day
            );
            if (mapDays.includes(dayOfWeek)) {
              const day = date.format("YYYY-MM-DD");
              const checkIn = schedule.calendarList[0].checkIn;
              const checkOut = schedule.calendarList[0].checkOut;

              const start = day + " " + checkIn;
              const end = day + " " + checkOut;

              const event = {
                id: schedule.id,
                title: "Agendamento do Mac",
                time: {
                  start: start.slice(0, -3),
                  end: end.slice(0, -3),
                },
                disableDnD: ["month", "week", "day"],
                colorScheme: "group",
                macUser: schedule.macUser,
                computerPassword: schedule.computerPassword,
                alias: schedule.alias,
                rustDeskId:schedule.rustDeskId,
                apiPassword: schedule.apiPassword,
                description: `
                  <div id='description-event-${schedule.id}' class='description-event'>
                    <button class='button-event' id='button-event-${schedule.id}'>Veja as instruções e acesse o Mac</button>
                    <br />
                    <b>Rustdesk:</b>
                    <div class='text-event'>
                      <p><b>ID/Endereço local:</b> ${schedule.alias}</p>
                      <button id='button-alias-${schedule.id}' title='copiar texto'>
                        <img id='image-id' src='' alt='copiar texto' />
                      </button>
                    </div>
                    <div class='text-event'>
                      <p><b>ID/Endereço remoto:</b> ${schedule.rustDeskId}</p>
                      <button id='button-rust-desk-${schedule.id}' title='copiar texto'>
                        <img id='image-id' src='' alt='copiar texto' />
                      </button>
                    </div>
                    <div class='text-event'>
                      <p><b>Senha:</b> ${schedule.apiPassword}</p>
                      <button id='button-api-password-${schedule.id}' title='copiar texto'>
                        <img id='image-id' src='' alt='copiar texto' />
                      </button>
                    </div>
                    <br />
                    <b>Mac:</b>
                    <div class='text-event'>
                      <p><b>Usuário:</b> ${schedule.macUser}</p>
                    </div>
                    <div class='text-event'>
                      <p><b>Senha:</b> ${schedule.computerPassword}</p>
                    </div>
                  </div>`,
              };

              events.push(event);
            }
          }
        });
        this.schedules = events;
        this.schedules.sort(this.compareByStartTime);

        const now = new Date();
        this.schedules = this.schedules.filter((item: any) => {
          const endTime = new Date(item.time.end);
          return endTime >= now;
        });
        for (let i = 0; i < this.schedules.length; i++) {
          if (this.compareStartDate(this.schedules[i].time.end)) {
            this.formatNextDate(
              this.schedules[0].id,
              this.schedules[0].time.start,
              this.schedules[0].time.end
            );
            break;
          }
        }
      });
    },
    startEvent(event: any): void {
      const id = event.clickedEvent.id;
      setTimeout(() => {
        const buttonEvent = document.getElementById(`button-event-${id}`);
        this.copyButtons(event.clickedEvent.macUser, `button-user-mac-${id}`);
        this.copyButtons(
          event.clickedEvent.computerPassword,
          `button-computer-password-${id}`
        );
        this.copyButtons(event.clickedEvent.alias, `button-alias-${id}`);
        this.copyButtons(
          event.clickedEvent.apiPassword,
          `button-api-password-${id}`
        );
        this.copyButtons(event.clickedEvent.rustDeskId, `button-rust-desk-${id}`)
        if (buttonEvent) {
          buttonEvent.style.display = "block";
          buttonEvent.addEventListener("click", () => {
            this.goToMac(id);
          });
        }
      }, 100);
    },
    copyButtons(text: string, buttonName: string): void {
      const button = document.getElementById(`${buttonName}`);
      if (button) {
        const image: any = button.querySelector("#image-id");
        button.style.display = "flex";

        if (image) {
          image.src = require("@/assets/images/copy.png");
        }
        button.addEventListener("click", () => {
          const textArea = document.createElement("textarea");
          textArea.value = text;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand("copy");
          this.$toast.add(ToastFactory.success("Copiado!"));
          document.body.removeChild(textArea);
        });
      }
    },
    formatNextDate(id: string, startDate: string, endDate: string): void {
      const startDateTimeString = startDate;
      const endDateTimeString = endDate;
      const [startDatePart, startTimePart] = startDateTimeString.split(" ");
      const [startYear, startMonth, startDay] = startDatePart.split("-");
      const formattedStartDate = `${startDay}/${startMonth}/${startYear}`;
      this.nextDate.startDate = formattedStartDate;
      this.nextDate.startHour = startTimePart;
      const [endDatePart, endTimePart] = endDateTimeString.split(" ");
      const [year, month, day] = endDatePart.split("-");
      const formattedEndDate = `${day}/${month}/${year}`;
      this.nextDate.endDate = formattedEndDate;
      this.nextDate.endHour = endTimePart;
      this.nextDate.id = id;
    },
    compareByStartTime(a: any, b: any) {
      const startTimeA: any = new Date(a.time.start);
      const startTimeB: any = new Date(b.time.start);
      return startTimeA - startTimeB;
    },
    compareStartDate(date: string): boolean {
      var result = false;
      var parts = date.split(/[\s-:]/);

      var year = parseInt(parts[0]);
      var month = parseInt(parts[1]) - 1;
      var day = parseInt(parts[2]);
      var hour = parseInt(parts[3]);
      var minute = parseInt(parts[4]);

      var currentDate = new Date();
      var targetDate = new Date(year, month, day, hour, minute);

      if (targetDate > currentDate) {
        result = true;
      }
      return result;
    },
  },
  mounted() {
    this.getCurrentBalance();
    this.getScheduleUser();
  },
});
